export default __webpack_public_path__ + "static/media/30_3_0.6d814af0.png";